import { ReportStatusFields } from 'Core/common/ReportCard/types'
import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum ReportBasicFields {
	reportLogId = 'reportLogId',
	reportName = 'reportName',
	fileName = 'fileName',
	user = 'user',
	runDate = 'runDate',
	status = 'status'
}

export enum ReportMainSearchFields {
	reportName = 'searchByName'
}

export enum ReportFilterFields {
	dateTo = 'dateTo',
	dateFrom = 'dateFrom',
	status = 'status'
}

export declare namespace Report {
	interface Basic {
		[ReportBasicFields.reportLogId]: number
		[ReportBasicFields.reportName]: BasicString
		[ReportBasicFields.fileName]: BasicString
		[ReportBasicFields.user]: BasicString
		[ReportBasicFields.runDate]: BasicString
		[ReportBasicFields.status]: ReportStatusFields | null
	}

	namespace Search {
		interface Config {
			[ReportMainSearchFields.reportName]: ConfigItem<ReportMainSearchFields>
		}

		interface Result {
			[ReportMainSearchFields.reportName]: ConfigItem<ReportMainSearchFields>
		}
	}

	namespace Filter {
		interface Config {
			[ReportFilterFields.dateFrom]: ConfigFilterItem<string, null>
			[ReportFilterFields.dateTo]: ConfigFilterItem<string, null>
			[ReportFilterFields.status]: ConfigFilterItem<string, string>
		}
	}
}
